<template>
  <div class="is-marginless is-paddingless section">
    <div class="entete">
      <div class="columns">
        <div class="column">
          <div class="title is-size-3">{{ $t('listeExpedition.title') }}</div>
          <app-breadcrumb :breadcrumb="breadcrumb" />
        </div>
      </div>
    </div>
    <onglet-list/>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action :options="actions" @handleAction="handleAction"
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="hasASelection"></selecteur-action>
          </div>
          <div class="column is-narrow">
            <form @submit.prevent="recherche()">
              <b-input :placeholder="$t('listeExpedition.actions.search')"
                      type="search"
                      icon="magnify"
                      v-model="critereRecherche.auto">
              </b-input>
            </form>
          </div>
          <div class="column is-narrow">
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{ $t('listeEcheances.actions.filtre') }}
                <label class="has-text-weight-bold"
                  :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <parametrage-table :reference-table="referenceTable"
          @endLoadParamtre="arrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <div class="tableWithPerPageSelection">
      <v-server-table url="" v-if="mountedLoadingEnd && arrayRendering" :columns="columns"
        class="tableWithChildRow" :options="options"
        @loaded="finLoading" @loading="debutLoading" :ref="referenceTable">
        <div slot="selected" slot-scope="props">
          <b-checkbox v-model="props.row.selected" class="has-text-centered"
                      @input="selectionOtExpeditionLivraison(props.row)">
          </b-checkbox>
        </div>
        <template #nom="{ row }">
          <div class="has-text-left">{{ row.otExpeditions[0].lieuDeLivraisonNomCommercial }}</div>
        </template>
        <template #adresse="{ row }">
          <div class="has-text-left">{{ getAdresse(row) }}</div>
        </template>
        <template #quantite="{ row }">
          <div class="has-text-right">{{ calculQuantiteRegroupement(row) }}</div>
        </template>
        <template #nbOt="{ row }">
          <div class="has-text-right">{{ calculNbOt(row) }}</div>
        </template>
        <template #afterTable>
          <table-items-in-view
            :perPage="resultPerPage"
            @input='$refs[referenceTable].setLimit($event)' />
        </template>
        <template #expedie = "{ row }">
          <div class="has-text-centered">
            <btn-action-icon
              :permission="permCommandes.maj"
              @is-click="expedieRegroupement(row)"
              icon-type="is-primary"
              :tooltip-label="$t('listeExpedition.table.expedie')"
              icon="cube-send">
            </btn-action-icon>
          </div>
        </template>
        <template v-slot:child_row="{ row }">
          <otExpeditionLivraisonChildRow
            :data="row"
            @expedie="applyMassExpedition">
          </otExpeditionLivraisonChildRow>
        </template>
      </v-server-table>
    </div>
    <transition name="custom-classes-transition"
        enter-active-class="animate__animated animate__slideInRight"
        leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-ot-expedition
          ref="filtreListeOtExpedition"
          @toggleFiltre="setShowFiltre"
          @recherche="makeRechercheFilter()"/>
      </div>
    </transition>
    <b-modal
      v-model="isComponentChangerEtatOtTechnique"
      @close="otsSelected = []"
      class="modal"
      has-modal-card>
      <pop-up-changer-etat-expedition
        v-if="isComponentChangerEtatOtTechnique"
        :dataOtsExpeditions="otsSelected"
        @refresh="refreshPage">
      </pop-up-changer-etat-expedition>
    </b-modal>
  </div>
</template>

<script>

import { cloneDeep } from 'lodash';
import selecteurAction from '@/components/general/selecteurAction';
import parametrageTable from '@/components/general/parametrageTable';
import AppBreadcrumb from '@/components/general/breadcrumb';
import OngletList from '@/components/logistique/bonExpedition/list/ongletList';
import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import {
  NO_PER_PAGE_VALUE, SORT_ICON, TEXTS, RESULTS_PER_PAGE,
} from '@/configuration/clientTableConf';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import { REFERENCE_TABLE_EXPEDITION_LIVRAISON } from '@/configuration/general/referenceTableConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import otExpeditionLivraisonChildRow from '@/components/logistique/ordreTravail/expedition/otExpeditionLivraisonChildRow';
import { ORDRE_TRAVAIL_EXPEDITION, BON_EXPEDITION } from '@/configuration/logistique/permissionsLogistiqueConf';
import filtreListeOtExpedition from '@/components/logistique/ordreTravail/expedition/filtreListeOtExpedition';
import tableItemsInView from '@/components/general/TableItemsInView';
import { SET_OT_SELECT } from '@/store/modules/logistique/otExpeditionLivraison-mutation-type';
import formatDateIso from '@/services/general/formatIsoDate';
import { ACTION_MASS_EXPEDITION, ACTION_EDITION_BON_LIVRAISON } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import popUpChangerEtatExpedition from '@/components/logistique/ordreTravail/expedition/p_changerEtatExpedition';
import getDataExpeditionFromOtExpeditionLivraisons from '@/services/logistique/ordreTravail/expedition/transformForPopupExpedition';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import BtnActionIcon from '@/components/general/btnActionIcon';
import { editionOts } from '@/services/logistique/ordreTravail/expedition/bonExpeditionService';
import transformer from '@/services/logistique/ordreTravail/expedition/dataTransformer';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const OtExpeditionLivraison = createNamespacedHelpers('otExpeditionLivraison');
const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'OtExpeditionLivraison',
  data() {
    return {
      referenceTable: REFERENCE_TABLE_EXPEDITION_LIVRAISON,
      arrayRendering: false,
      mountedLoadingEnd: false,
      showFiltre: false,
      permCommandes: ORDRE_TRAVAIL_EXPEDITION,
      resultPerPage: RESULTS_PER_PAGE,
      selectAllValue: false,
      isComponentChangerEtatOtTechnique: false,
      etatAchanger: null,
      messageHeader: '',
      otsSelected: [],
    };
  },
  components: {
    AppBreadcrumb,
    OngletList,
    selecteurAction,
    parametrageTable,
    filtreListeOtExpedition,
    tableItemsInView,
    popUpChangerEtatExpedition,
    otExpeditionLivraisonChildRow,
    BtnActionIcon,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...OtExpeditionLivraison.mapGetters({
      otExpeditionLivraisons: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
      lastPayload: 'lastPayload',
    }),
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    iconSelectTotal() {
      if (this.otExpeditionLivraisons.every(item => item.otExpeditions.every(ot => ot.selected))) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    hasASelection() {
      return this.otExpeditionLivraisons
        .some(otExLivraison => otExLivraison.otExpeditions.some(otEx => otEx.selected));
    },
    actions() {
      const actions = [
        {
          action: ACTION_MASS_EXPEDITION,
          translation: 'listeOrdreTravailTech.actions.expedie',
        },
        {
          action: ACTION_EDITION_BON_LIVRAISON,
          translation: 'listeOrdreTravailTech.actions.bonLivraison',
        },
      ];
      return actions;
    },
    columns() {
      return ['selected', 'nom', 'adresse', 'nbOt', 'quantite', 'expedie'];
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'societeId', 'dates'];
      let nombreCritere = calculNombreCritere(this.critereRecherche, banCritereKey);
      if (this.critereRecherche.dates
        && (this.critereRecherche.dates.dateDebut || this.critereRecherche.dates.dateFin)) {
        nombreCritere += 1;
      }
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          nom: this.$i18n.t('listeExpedition.table.nom'),
          adresse: this.$i18n.t('listeExpedition.table.adresse'),
          nbOt: this.$i18n.t('listeExpedition.table.nbOt'),
          quantite: this.$i18n.t('listeExpedition.table.quantite'),
          expedie: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        columnsClasses: {
          selected: 'colonneSelected',
          nbOt: 'colonneWidth270px',
          quantite: 'colonneWidth270px',
          expedie: 'colonneSelected',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['nom', 'adresse'],
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          data.query.societeId = this.societeActiveId;

          if (data.query.dates) {
            if (data.query.dates.dateDebut) {
              data.query.dates.dateDebut = formatDateIso(
                data.query.dates.dateDebut,
              );
            }
            if (data.query.dates.dateFin) {
              data.query.dates.dateFin = formatDateIso(
                data.query.dates.dateFin,
              );
            }
          }
          data.query.campagneIds = this.critereRecherche.campagneIds.map(campagne => campagne.id);
          data.query.lieuLivraisonIds = this.critereRecherche.lieuLivraisonIds
            .map(tiers => tiers.id);
          data.query.enseigneIds = this.critereRecherche.enseigneIds
            .map(tiers => tiers.id);
          data.query.dispositifIds = this.critereRecherche.dispositifIds
            .map(dispositif => dispositif.id);
          data.query.types = this.critereRecherche.types
            .map(type => type.id);
          return this.actionLoadOtExpeditionLivraison(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.otExpeditionLivraisons,
            count: this.totalCount,
          };
        }),
      };
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeExpedition.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        {
          title: this.$i18n.t('listeExpedition.breadcrumb.expeditions'),
          route: { name: 'l.logistique.ordre_travail_expedition' },
          isActive: true,
        },
      ];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...OtExpeditionLivraison.mapActions({
      actionLoadOtExpeditionLivraison: 'loadOtExpeditionLivraison',
    }),
    ...OtExpeditionLivraison.mapMutations({
      setOtSelect: SET_OT_SELECT,
    }),
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    getAdresse(row) {
      return adressFullStringGetter(row);
    },
    calculQuantiteRegroupement(row) {
      return row.otExpeditions.reduce((a, b) => a + b.quantite, 0);
    },
    calculNbOt(row) {
      return row.otExpeditions.length;
    },
    selectAll() {
      this.selectAllValue = !this.selectAllValue;
      this.otExpeditionLivraisons.forEach((el) => {
        el.selected = this.selectAllValue;
        this.setOtSelect({ lieuLivraisonId: el.id });
      });
    },
    selectionOtExpeditionLivraison(row) {
      this.setOtSelect({ lieuLivraisonId: row.id });
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeOtExpedition.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiser() {
      await this.$refs.filtreListeOtExpedition.initializeFiltre();
      await this.$refs.filtreListeOtExpedition.viderCritere();
      this.$refs.filtreListeOtExpedition.appliquerCritere();
      this.showFiltre = false;
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    handleAction(action) {
      switch (action) {
        case ACTION_MASS_EXPEDITION:
          this.applyMassExpedition();
          break;
        case ACTION_EDITION_BON_LIVRAISON:
          this.applyEditionBonLivraison();
          break;
        default:
          break;
      }
    },
    async applyEditionBonLivraison() {
      if (!this.checkPermissions(BON_EXPEDITION.editer)) {
        this.showPopUp();
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      const otIds = this.otExpeditionLivraisons
        .filter(el => el.otExpeditions.some(otEx => otEx.selected))
        .flatMap(el => el.otExpeditions.filter(oe => oe.selected).map(oe => oe.id));
      const parametresAdditionnels = { Sorting: transformer(this.lastPayload).Sorting };
      try {
        await editionOts(otIds, TYPE_PDF, parametresAdditionnels);
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    expedieRegroupement(row) {
      const otIds = [];
      if (row.otExpeditions?.length > 0) {
        row.otExpeditions.forEach(ot => otIds.push(ot.id));
      }
      this.applyMassExpedition(otIds);
    },
    applyMassExpedition(listOtIds) {
      let listOts = null;
      if (listOtIds) {
        listOts = this.otExpeditionLivraisons
          .filter(oel => oel.otExpeditions.some(otEx => listOtIds.includes(otEx.id)));
      } else {
        listOts = this.otExpeditionLivraisons
          .filter(oel => oel.otExpeditions.some(otEx => otEx.selected));
      }
      this.otsSelected = getDataExpeditionFromOtExpeditionLivraisons(listOts, listOtIds);
      this.isComponentChangerEtatOtTechnique = true;
    },
    async refreshPage() {
      this.isComponentChangerEtatOtTechnique = false;
      await this.recherche();
    },
  },
  async mounted() {
    this.setInformationPage(this.$t('pageLogistique.expedition.liste'));
    await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key]);
    this.mountedLoadingEnd = true;
  },
};
</script>
